export default "__VITE_ASSET__Ca4C08t9__"